// import {t} from "i18next";
import {t} from "i18next";
import {all, call, delay, put, select, takeLatest} from "redux-saga/effects";
import {setErrorNotification} from "store/features/notificationsSlice";
import {deleteSnapshots, fetchSnapshots} from "api/savedInvestigations";
import {
  filterOutDeletedUsers,
  prettyPrintUsernamesFromArray
} from "utils/users";
import {
  bulkDeleteSavedInvestigations,
  bulkDeleteSavedInvestigationsFailure,
  bulkDeleteSavedInvestigationsSuccess,
  fetchSavedInvestigations,
  fetchSavedInvestigationsFailure,
  fetchSavedInvestigationsSuccess
} from "../features/savedInvestigationsSlice";
import * as selectors from "../selectors";

export function* fetchSavedInvestigationsSaga(action) {
  try {
    const savedInvestigations = yield call(fetchSnapshots, action.payload);
    const usersList = yield select(selectors.selectAllUsers);
    const filteredInvestigations = {
      dataRows: filterOutDeletedUsers(savedInvestigations.dataRows, usersList),
      ...savedInvestigations
    };
    filteredInvestigations.dataRows = prettyPrintUsernamesFromArray(
      filteredInvestigations.dataRows,
      usersList
    );
    yield put(fetchSavedInvestigationsSuccess(filteredInvestigations));
  } catch (error) {
    console.error(error);
    yield put(fetchSavedInvestigationsFailure(error.data));

    yield put(
      setErrorNotification(t("investigate.savedInvestigations.loadingError"))
    );
  }
}

export function* deleteSavedInvestigationsSaga(action) {
  try {
    yield call(deleteSnapshots, action.payload.investigations);
    yield delay(1000);
    yield put(
      bulkDeleteSavedInvestigationsSuccess(action.payload.filterSettings)
    );
  } catch (error) {
    console.error(error);
    yield put(bulkDeleteSavedInvestigationsFailure(action));
  }
}

export default function* savedInvestigationsSaga() {
  yield all([
    yield takeLatest(
      [fetchSavedInvestigations, bulkDeleteSavedInvestigationsSuccess],
      fetchSavedInvestigationsSaga
    ),
    yield takeLatest(
      bulkDeleteSavedInvestigations,
      deleteSavedInvestigationsSaga
    )
  ]);
}
